<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M12.08,4.970000537528992C10.82,4.260000537528992,8.81,2.8200005375289914,8.13,1.2700005375289918C7.88,0.7000005375289917,6.67,0.9599998375289917,6.81,2.5200005375289916C6.9,3.4500005375289917,7.7,4.420000537528992,8.11,5.000000537528992C8.11,5.000000537528992,1.5,5.000000537528992,1.5,5.000000537528992C0.67,5.000000537528992,0,5.670000537528992,0,6.500000537528992C0,7.330000537528992,0.67,8.000000537528992,1.5,8.000000537528992C1.5,8.000000537528992,5.55,8.000000537528992,5.55,8.000000537528992C5.55,8.000000537528992,6.18,8.010000537528992,6.18,8.010000537528992C5.74,8.210000537528991,5.43,8.700000537528991,5.43,9.260000537528992C5.43,9.780000537528991,5.69,10.22000053752899,6.06,10.450000537528991C5.8,10.700000537528991,5.64,11.060010537528992,5.64,11.480010537528992C5.64,12.090010537528991,5.99,12.600010537528991,6.48,12.770010537528991C6.3,13.010010537528991,6.19,13.310010537528992,6.19,13.650010537528992C6.19,14.400010537528992,6.73,15.000010537528992,7.38,15.000010537528992C7.38,15.000010537528992,8.17,15.000010537528992,8.17,15.000010537528992C10.79,15.000010537528992,12.64,14.720010537528992,13.88,14.080010537528992C15.39,13.290010537528993,16,11.940010537528991,16,9.860000537528991C16,6.070000537528991,14.05,5.890000537528992,12.08,4.970000537528992C12.08,4.970000537528992,12.08,4.970000537528992,12.08,4.970000537528992Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'HandLeft',
} as DefineComponent
</script>
